import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LLCTransaction } from '@models/llc-mortgages';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';

import { LLCMortgageState } from '@state/mortgages/llc-mortgage/llc-mortgage.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface SyncAmendmentUsersComponentData {
	transactionId: string;
}

@UntilDestroy()
@Component({
	selector: 'app-sync-amendment-users',
	templateUrl: './sync-amendment-users.component.html',
	standalone: false,
})
export class SyncAmendmentUsersComponent implements OnInit {
	public transaction: LLCTransaction;

	@Select(LLCMortgageState.getLLCMortgage) llcMortgageFilterFn$: Observable<
		(id: string) => LLCTransaction
	>;

	constructor(
		public dialogRef: MatDialogRef<SyncAmendmentUsersComponent>,
		@Inject(MAT_DIALOG_DATA) public _data: SyncAmendmentUsersComponentData,
	) {}

	ngOnInit(): void {
		//fetch the latest transaction from the store
		this.getLLCMortgage$(this._data.transactionId).subscribe((_transaction) => {
			this.transaction = _transaction;
		});
	}

	getLLCMortgage$ = (id: string): Observable<LLCTransaction> =>
		this.llcMortgageFilterFn$.pipe(
			untilDestroyed(this),
			map((x) => x(id)),
		);

	next() {
		this.dialogRef.close();
	}
}
